export default __webpack_public_path__ + "static/media/mitrassearingeye.af059a3e.png";